const messages = {
  de: {
    feedbackTitle: "Feedback/Idee zu Quizshow Studio",
    feedbackSend: "Feedback senden",
    feedbackThanks: "Danke. Dein Feedback wurde angenommen.",
  },
  en: {
    feedbackTitle: "Feedback/idea for Quizshow Studio",
    feedbackSend: "Send feedback",
    feedbackThanks: "Thank you. Your feedback was accepted.",
  },
} as const;

export type Locale = keyof typeof messages;
export type MessageKey = keyof (typeof messages)["de"];

export function translate(key: MessageKey, locale: Locale = "de"): string {
  return messages[locale][key];
}
